import React from 'react';
import Grid from '@material-ui/core/Grid';

import Header from '@/components/Header';
import SkaterBoxscore from '@/components/TeamBoxscore/Skater';
import GoalieBoxscore from '@/components/TeamBoxscore/Goalie';



const TeamBoxscore = ({ goalies, skaters, team, isFinal }) => {
  const filteredGoalies = goalies.filter(goalie => goalie.team === team && !goalie.isHidden);
  const filteredSkaters = skaters.filter(skater => skater.team === team);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Header title="Skaters" />
        <SkaterBoxscore isFinal={isFinal} skaters={filteredSkaters} />
      </Grid>
      <Grid item xs={12}>
        <Header title="Goalies" />
        <GoalieBoxscore isFinal={isFinal} goalies={filteredGoalies} />
      </Grid>
    </Grid>
  );
}


export default TeamBoxscore;